export default {
      id: "icon-check-usage",
      viewBox: "0 0 62 62",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-check",
      toString: function () {
        return this.url;
      }
    }